// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:56:10.118Z
// Property: Hathaway Court (ID: 6767906449166893)
// Collections: 20 amenities, 4 floorplans (live), 47 photos, 40 POIs, 3 reviews, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166893",
  "property_external_id": "495804",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/hathaway-court-apartments-wilsonville-or/5b5q2tm/",
  "property_google_business_url": "https://www.google.com/maps/place/Hathaway+Court+Apartments/data=!4m2!3m1!1s0x0:0x74496c4c784e60c4?sa=X&ved=2ahUKEwjk8_fmi7ySAxVbnGoFHWAJHoQQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495804 p0505472",
  "property_status": null,
  "property_slug": "hathaway-court",
  "property_name": "Hathaway Court",
  "property_website_url": "https://www.wilsonvilleoregonapartments.com/",
  "property_domain": "https://www.wilsonvilleoregonapartments.com/",
  "property_address": "29501 SW Meadows Loop",
  "property_full_address": "29501 SW Meadows Loop, Wilsonville, 97070",
  "property_address_1": "29501 SW Meadows Loop",
  "property_address_2": null,
  "property_address_city": "Wilsonville",
  "property_address_state": "Wilsonville",
  "property_address_zip_full": null,
  "property_address_zip": "97070",
  "property_address_country": "US",
  "property_address_county": "Clackamas County",
  "property_neighborhood_address": "Wilsonville",
  "property_address_latitude": "45.305903",
  "property_address_longitude": "-122.750818",
  "property_email": "hathaway@ctlmanagement.com",
  "property_phone": "(844) 851-3809",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Hathaway Court in Wilsonville, OR, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, each designed with you in mind. Enjoy top-notch amenities including a refreshing pool, fitness center, and a cozy clubhouse. Ready to find your new home? Explore our available units today!",
  "property_long_description": "Welcome to Hathaway Court, your ideal apartment community nestled in the picturesque landscape of Wilsonville, OR. Offering a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, we cater to a range of lifestyles and needs. Enjoy the spacious layouts featuring vaulted ceilings and walk-in closets, perfect for making every inch of your home both functional and stylish.\n\nAt Hathaway Court, our extensive amenities provide the perfect blend of relaxation and recreation. Dive into our sparkling pool on warm summer days, maintain your fitness regime in our state-of-the-art fitness center, or unwind in the soothing spa. For families, our playground is an exciting retreat, while our clubhouse serves as a perfect gathering spot for neighbors and friends. \n\nStay connected with high-speed internet access and take advantage of our convenient online services. Our apartments come fully equipped with modern conveniences, including air conditioning, a washer/dryer, a microwave, and a refrigerator. We also offer smoke-free living, wheelchair-accessible rooms, and extra storage space for your convenience.\n\nLooking for entertainment? Enjoy movie nights in our media center or challenge friends in our gameroom. With a dedicated property manager on-site, you’ll always have the support you need. \n\nDon’t wait any longer to discover your perfect home at Hathaway Court! Browse our availability today or schedule a tour to explore our vibrant community and find the lifestyle you've been searching for. Your new beginning awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d2bce-838d-70b3-a699-b0679140610d.webp",
  "property_featured_image_media": {
    "alt_text": "Pathway leading to building entrance with stone accents and decorative fence",
    "public_id": "019d2bce-838d-70b3-a699-b0679140610d",
    "storage_key": "property/6767906449166893/019d2bce-838d-70b3-a699-b0679140610d.webp",
    "width": 2048,
    "height": 956
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.33333333333334",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Application & Deposit: A $50 fee per applicant and a refundable security deposit of $400 are required.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $25 per pet\nDeposit: $400 per pet",
  "property_online_leasing_url": "https://wilsonvilleoregonapartments.securecafe.com/onlineleasing/hathaway-court-0/floorplans.aspx",
  "property_resident_portal_url": "https://wilsonvilleoregonapartments.securecafenet.com/residentservices/hathaway-court-0/userlogin",
  "property_apply_now_url": "https://wilsonvilleoregonapartments.securecafe.com/onlineleasing/hathaway-court-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d73d5-73d1-764f-b121-e05eb58babd1.webp",
  "property_primary_logo_media": {
    "alt_text": "Hathaway Court Apartments and Townhomes logo",
    "public_id": "019d73d5-73d1-764f-b121-e05eb58babd1",
    "storage_key": "property/6767906449166893/019d73d5-73d1-764f-b121-e05eb58babd1.webp",
    "width": 794,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d73d5-72cf-7024-8caf-9aa608839432.webp",
  "property_secondary_logo_media": {
    "alt_text": "Hathaway Court Apartments and Townhomes logo",
    "public_id": "019d73d5-72cf-7024-8caf-9aa608839432",
    "storage_key": "property/6767906449166893/019d73d5-72cf-7024-8caf-9aa608839432.webp",
    "width": 803,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019de0b2-a46b-750c-bf71-211a498b011e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Blank white banner with dark grey borders",
    "public_id": "019de0b2-a46b-750c-bf71-211a498b011e",
    "storage_key": "property/6767906449166893/019de0b2-a46b-750c-bf71-211a498b011e.webp",
    "width": 794,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019de0b2-97d8-75ec-aec5-0bd29df6a2fd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black bar graphic",
    "public_id": "019de0b2-97d8-75ec-aec5-0bd29df6a2fd",
    "storage_key": "property/6767906449166893/019de0b2-97d8-75ec-aec5-0bd29df6a2fd.webp",
    "width": 794,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "699 - 1085",
  "property_sqft_min": "699",
  "property_sqft_max": "1085",
  "property_price_range": "1470 - 3380",
  "property_price_min": "1470",
  "property_price_max": "3380",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/hathawaycourtapartmenthomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ-3-xQVhulVQRxGBOeExsSXQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/hathaway-court-apartments-wilsonville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hathaway Court",
  "property_home_romance_title": "Embrace Life, Love Your New Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to Hathaway Court in Wilsonville, OR, where comfort meets convenience. Choose from spacious one, two, or three-bedroom layouts, all featuring modern amenities like a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. Enjoy luxurious living with walk-in closets, vaulted ceilings, and online services at your fingertips!",
  "property_home_floorplans_blurb": "Welcome to Hathaway Court in beautiful Wilsonville, OR, where contemporary style meets comfort. With a variety of thoughtfully designed floor plans, each apartment is crafted to suit your lifestyle. Browse our available homes and envision your next chapter in a community that truly feels like home.",
  "property_home_gallery_blurb": "At Hathaway Court in Wilsonville, OR, choose from versatile one, two, and three-bedroom floor plans tailored for your lifestyle. Embrace a world of amenities, from a refreshing pool and energizing fitness center to a cozy clubhouse and movie theater. Picture yourself living here, where comfort meets convenience!",
  "property_home_neighborhood_blurb": "At Hathaway Court in Wilsonville, experience a vibrant lifestyle surrounded by enriching attractions. From the historic charm of Old Aurora Colony Museum to the educational offerings at the Oregon Institute of Technology, our community bridges comfort and culture, creating an ideal backdrop for your next chapter. See what's around our community today!",
  "property_home_reviews_blurb": "Nestled in the heart of Wilsonville, Hathaway Court offers more than just a place to live; it's a vibrant community. Residents rave about the friendly atmosphere, with one saying, “The sense of community here is wonderful!” Experience it for yourself—check out what our residents are saying today!",
  "property_neighborhood_blurb": "Nestled in the heart of Wilsonville, Hathaway Court offers you more than just a place to live. With nearby attractions like the Tualatin Public Library, the historic Old Aurora Colony Museum, and beautiful Cook Family Park, you’ll find a vibrant community full of cultural gems and recreational opportunities. Embrace your new lifestyle!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Hathaway Court in Wilsonville, OR, your ideal lifestyle awaits. Choose from spacious one, two, or three-bedroom layouts, each adorned with modern amenities. Dive into our refreshing pool, break a sweat in the fitness center, or unwind in the cozy clubhouse. Elevate your living experience today!",
  "property_applynow_blurb": "At Hathaway Court in Wilsonville, OR, luxury meets comfort across our inviting one, two, and three-bedroom floor plans. Enjoy refreshing afternoons by the pool, stay active in our fitness center, or unwind in the media center. With amenities like walk-in closets and online services, your perfect home awaits. Lease online today!",
  "property_contactus_blurb": "At Hathaway Court in Wilsonville, OR, our diverse floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats, spacious two-bedroom havens, or family-friendly three-bedroom homes. We’re here to assist you in finding your perfect fit—have questions? Contact our leasing team today for personalized guidance!",
  "property_faqs_blurb": "At Hathaway Court in Wilsonville, OR, we offer a range of thoughtfully designed floor plans—choose from one, two, or three-bedroom apartments. With every detail considered, you’re sure to find your perfect home. For all your inquiries, visit our FAQs page for helpful insights into our vibrant community.",
  "property_floorplans_blurb": "At Hathaway Court in Wilsonville, OR, our thoughtfully designed one, two, and three-bedroom apartments cater to your unique lifestyle. Each floor plan showcases spacious living and modern amenities, ensuring comfort and convenience. Browse our available apartment homes today to discover the ideal space for you and your loved ones.",
  "property_gallery_blurb": "At Hathaway Court in Wilsonville, OR, every detail reflects comfort and style. From spacious one, two, and three-bedroom floor plans to resort-style amenities like a sparkling pool and cozy movie theater, it's a place where life flourishes. Picture yourself living here—your dream home awaits! Explore our photo gallery now!",
  "property_interactivemap_blurb": "Welcome to Hathaway Court in Wilsonville, OR, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, complete with modern amenities like a sparkling pool and energizing fitness center. Ready to find your ideal home? Navigate our interactive community map to explore available options today!",
  "property_pets_blurb": "At Hathaway Court in Wilsonville, OR, your furry friends are more than welcome! With a pet-friendly policy for cats and dogs under 25 lbs, plus no deposit for small caged critters, your apartment becomes a cozy haven for all life’s cherished companions. It's the perfect blend of comfort and companionship!",
  "property_referafriend_blurb": "At Hathaway Court in Wilsonville, OR, great friends make great neighbors! With spacious one, two, and three-bedroom floor plans, there’s a perfect home for everyone. Share the joy of vibrant living and invite a friend to join our community today—craft unforgettable memories together!",
  "property_residentaccess_blurb": "Welcome to Hathaway Court in Wilsonville, OR, where comfort meets convenience. With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Log into your resident portal to effortlessly handle rent payments, schedule maintenance, and unlock a seamless living experience tailored just for you!",
  "property_reviews_blurb": "At Hathaway Court in Wilsonville, OR, residents rave about the vibrant community and exceptional service. One happy tenant shares, \"The staff goes above and beyond to make us feel at home!\" Dive into our reviews to uncover more glowing experiences and see what life at Hathaway Court is truly like!",
  "property_created_at": "1762784877622",
  "property_scheduletour_blurb": "At Hathaway Court in Wilsonville, OR, choose from thoughtfully designed one, two, or three-bedroom floor plans that perfectly align with your lifestyle. Schedule a tour today and envision your new home while hearing directly from our residents about the vibrant community they love! Your ideal living space awaits.",
  "property_thankyou_blurb": "Thank you for your interest in Hathaway Court! Nestled in the heart of Wilsonville, OR, our diverse floor plans—from cozy one bedrooms to spacious three bedrooms—provide the perfect backdrop for your lifestyle. Our team will reach out soon to help you find your ideal home.",
  "property_virtualtours_blurb": "Welcome to Hathaway Court in beautiful Wilsonville, OR, where stylish one, two, and three-bedroom apartments await your unique touch. Embrace an immersive virtual tour of our vibrant community and see firsthand the perfect blend of comfort and modern living. Your ideal home is just a click away!",
  "property_copyright": "2025 All Rights Reserved. Hathaway Court",
  "property_seo_title_home": "Hathaway Court |  Apartments in Wilsonville, OR",
  "property_seo_description_home": "Discover vibrant living at Hathaway Court in Wilsonville, OR—spacious apartments, excellent amenities, and a community tailored for you!",
  "property_seo_title_floorplans": "Floor Plans | Wilsonville, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your fit at Hathaway Court in Wilsonville, OR! Explore our diverse one, two, and three-bedroom floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Wilsonville, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Hathaway Court in Wilsonville, OR! Dive into our pool, stay fit in our gym, or unwind in the spa—all in one vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Wilsonville, OR",
  "property_seo_description_gallery": "Picture life at Hathaway Court in Wilsonville, OR! Dive into our vibrant community with stunning amenities, spacious floor plans, and a welcoming atmosphere.",
  "property_seo_title_virtualtours": "Virtual Tours | Hathaway Court Apartments",
  "property_seo_description_virtualtours": "Explore Hathaway Court in Wilsonville, OR! Take a virtual tour of our one to three-bedroom apartments. Book your tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Hathaway Court Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Hathaway Court in Wilsonville, OR! Explore spacious floor plans and great amenities like a pool and fitness center.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wilsonville, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Hathaway Court in Wilsonville, OR! Dive into local favorites and hidden gems just steps from your new home. Your adventure awaits!",
  "property_seo_title_contact": "Contact Us | Hathaway Court",
  "property_seo_description_contact": "Connect with Hathaway Court in Wilsonville, OR! Check out our one, two, and three-bedroom floor plans. Got questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Wilsonville, OR",
  "property_seo_description_faqs": "Get answers to your questions about Hathaway Court in Wilsonville, OR. From floor plans to amenities, our FAQs provide all you need for ideal apartment living!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wilsonville, OR",
  "property_seo_description_reviews": "Experience life at Hathaway Court in Wilsonville, OR! From stunning floor plans to top-notch amenities, see what residents love about their home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Wilsonville, OR",
  "property_seo_description_applynow": "Elevate your lifestyle at Hathaway Court in Wilsonville, OR. Choose from spacious one to three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Hathaway Court",
  "property_seo_description_residentaccess": "Login to Hathaway Court's resident portal for easy rent payments, hassle-free maintenance requests, and seamless community updates in Wilsonville, OR!",
  "property_seo_title_referafriend": "Refer A Friend | Hathaway Court",
  "property_seo_description_referafriend": "Share the joy of living at Hathaway Court in Wilsonville! Refer a friend and create lasting memories in a vibrant community where neighbors become family.",
  "property_seo_title_scheduletour": "Schedule a Tour | Hathaway Court",
  "property_seo_description_scheduletour": "Discover modern living at Hathaway Court in Wilsonville, OR! Schedule a tour today to find your ideal apartment home.",
  "property_seo_title_privacy": "Privacy Policy | Hathaway Court",
  "property_seo_description_privacy": "Safeguarding your trust at Hathaway Court in Wilsonville, OR. Dive into our privacy policy to learn how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Hathaway Court",
  "property_seo_description_accessibility": "Join us at Hathaway Court in Wilsonville, where we prioritize digital inclusion and create a welcoming, connected community for all.",
  "property_seo_title_sitemap": "Sitemap | Hathaway Court",
  "property_seo_description_sitemap": "Uncover every corner of Hathaway Court in Wilsonville, OR. Navigate through our sitemap to find your perfect apartment and community features awaiting you!",
  "property_seo_title_thankyou": "Thank You | Hathaway Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Hathaway Court! Our team will connect with you soon to help you find your ideal apartment in beautiful Wilsonville, OR.",
  "property_seo_title_pets": "Pet Policy | Apartments in Wilsonville, Wilsonville",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874863920",
  "amenities": [
    {
      "id": "ec_f18e6f06b47b0e56eb78b642",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428930",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bf24d2002f913a914b72883",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428931",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fadfc990105dcd2746ea9713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428933",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa83fcf28cbc2e3a3c3f32f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428934",
      "title": "Community Library",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecad0632429f81ec03850704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428935",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41bde72d217ee7bf25fd8048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428938",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9abd04ea8f4036779891c2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428940",
      "title": "Indoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4da23782354238be8327e596",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428942",
      "title": "Multiple Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2928066f084cb798684e790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428937",
      "title": "Theater Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e4ee1e87b4972f09d076ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428944",
      "title": "Wading Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f46d8a94c9ce73785a667d93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428932",
      "title": "24-Hour Maintenance Guarantee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56931c4108dd9ea415e1fd5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428939",
      "title": "Ground Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edc35f0e645d8188c8151038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428941",
      "title": "Monthly Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f37f1e5db7fb2cf9c79a716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428946",
      "title": "Locked Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebddb8bbfca2319417a2da28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428947",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d9167bfa9754c6471677b0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428943",
      "title": "Scenic View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_808308806c604faf34e2c439",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428945",
      "title": "Vaulted Ceilings In Select Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_113a3d3e5c9f46503460ac0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428948",
      "title": "Walk-In Closets In Select Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7f808ab9759e9ac1380c57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428949",
      "title": "Washer And Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3e1f42c7db6522beeb661f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "yardi",
      "external_id": "80428936",
      "title": "End Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_868686b1-1c77-450e-abb8-f762b99b195f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-b67c-76fb-b0b0-d5215e9441b8.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a breakfast bar with bar stools.",
        "public_id": "019d08ac-b67c-76fb-b0b0-d5215e9441b8",
        "storage_key": "property/6767906449166893/019d08ac-b67c-76fb-b0b0-d5215e9441b8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Enjoy a meal or gather with friends at the community kitchen's breakfast bar, featuring modern appliances and comfortable seating.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a breakfast bar with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e98ad63-5354-4c3a-be49-e1cd613359ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-c28f-77fc-ab38-79089e1b816b.webp",
      "image_media": {
        "alt_text": "Indoor spa with wooden paneled walls and tiled surrounds.",
        "public_id": "019d08ac-c28f-77fc-ab38-79089e1b816b",
        "storage_key": "property/6767906449166893/019d08ac-c28f-77fc-ab38-79089e1b816b.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Relax and unwind in the indoor spa, featuring a soothing hot tub and comfortable seating area.",
      "link": "",
      "alt_text": "Indoor spa with wooden paneled walls and tiled surrounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d857c725-0cde-49c5-a2f6-85d908caac22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-56c7-72c5-a9e9-348313b4098b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a chandelier.",
        "public_id": "019d08ac-56c7-72c5-a9e9-348313b4098b",
        "storage_key": "property/6767906449166893/019d08ac-56c7-72c5-a9e9-348313b4098b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, elegant nightstands with lamps, and a decorative chandelier overhead.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5802e99c-0926-43a2-b223-51ad2fef3710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-ec44-724e-b9e6-5a6345debdda.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machines, and weight machines.",
        "public_id": "019d08ac-ec44-724e-b9e6-5a6345debdda",
        "storage_key": "property/6767906449166893/019d08ac-ec44-724e-b9e6-5a6345debdda.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, rowing machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a474de3b-1764-43f5-a43d-480c3d7d7f0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-47ba-7389-951c-5500b5e09b45.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large leather sectional sofa and coffee table.",
        "public_id": "019d08ac-47ba-7389-951c-5500b5e09b45",
        "storage_key": "property/6767906449166893/019d08ac-47ba-7389-951c-5500b5e09b45.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, featuring a plush leather sectional and stylish coffee table, perfect for entertaining guests or enjoying a quiet evening at home.",
      "link": "",
      "alt_text": "Spacious living room with a large leather sectional sofa and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0526aca6-84bf-417f-8d86-827778023f02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-bc48-706b-b89e-4dd086fe8a86.webp",
      "image_media": {
        "alt_text": "Communal lounge area with large wooden tables, a stone fireplace, and comfortable seating.",
        "public_id": "019d08ac-bc48-706b-b89e-4dd086fe8a86",
        "storage_key": "property/6767906449166893/019d08ac-bc48-706b-b89e-4dd086fe8a86.webp",
        "width": 2049,
        "height": 1466
      },
      "title": "Community",
      "description": "Gather in the spacious communal lounge, featuring a cozy stone fireplace, ample seating, and large tables perfect for social events or relaxation.",
      "link": "",
      "alt_text": "Communal lounge area with large wooden tables, a stone fireplace, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c46b7280-7ee2-4260-9871-970ce31eba61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-f591-774e-a2a8-64d442a7ef76.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structure.",
        "public_id": "019d08ac-f591-774e-a2a8-64d442a7ef76",
        "storage_key": "property/6767906449166893/019d08ac-f591-774e-a2a8-64d442a7ef76.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide and climbing structure for children.",
      "link": "",
      "alt_text": "Playground with slides and climbing structure.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5dbfd2ac-e31e-476a-88ed-8689f522d61e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-47b5-75da-a75a-a4258ff17512.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white cabinets, black appliances, and a glass-top dining table.",
        "public_id": "019d08ac-47b5-75da-a75a-a4258ff17512",
        "storage_key": "property/6767906449166893/019d08ac-47b5-75da-a75a-a4258ff17512.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Enjoy a bright and airy dining area adjacent to a fully equipped kitchen, perfect for everyday meals and entertaining guests.",
      "link": "",
      "alt_text": "Dining area and kitchen with white cabinets, black appliances, and a glass-top dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51f486da-0e8e-471c-b118-d391161efd31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-f3ac-716f-b2f5-071e8e3a7068.webp",
      "image_media": {
        "alt_text": "Row of garages with white doors and green trim, surrounded by trees.",
        "public_id": "019d08ac-f3ac-716f-b2f5-071e8e3a7068",
        "storage_key": "property/6767906449166893/019d08ac-f3ac-716f-b2f5-071e8e3a7068.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure garage parking is available at this community. Covered parking protects your vehicle from the elements.",
      "link": "",
      "alt_text": "Row of garages with white doors and green trim, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4df32943-bb83-4f24-883a-4327346470f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-d046-74b5-ad27-a81c4b0149a2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with covered parking and lush landscaping.",
        "public_id": "019d08ac-d046-74b5-ad27-a81c4b0149a2",
        "storage_key": "property/6767906449166893/019d08ac-d046-74b5-ad27-a81c4b0149a2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "A charming apartment building featuring a mix of siding colors and exterior staircases, surrounded by vibrant greenery and offering covered parking options.",
      "link": "",
      "alt_text": "Exterior view of apartment building with covered parking and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73db1e6b-8de9-4de3-9033-106f062bdbc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-ca3e-7468-bff5-de897a285585.webp",
      "image_media": {
        "alt_text": "Basketball hoop on a paved court with a grassy lawn and trees in the background.",
        "public_id": "019d08ac-ca3e-7468-bff5-de897a285585",
        "storage_key": "property/6767906449166893/019d08ac-ca3e-7468-bff5-de897a285585.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a basketball court set amidst lush greenery and mature trees.",
      "link": "",
      "alt_text": "Basketball hoop on a paved court with a grassy lawn and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ea66e26-13a8-47a1-90de-6d2d244979ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-e6d9-7468-a23d-5737d5fdd51b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d08ac-e6d9-7468-a23d-5737d5fdd51b",
        "storage_key": "property/6767906449166893/019d08ac-e6d9-7468-a23d-5737d5fdd51b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush greenery and comfortable seating. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af6eb2cf-5aad-4d98-b415-cda1420855a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-e41d-7089-aa96-0aa8b9e18231.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
        "public_id": "019d08ac-e41d-7089-aa96-0aa8b9e18231",
        "storage_key": "property/6767906449166893/019d08ac-e41d-7089-aa96-0aa8b9e18231.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1688459c-c1a4-4e8e-9d79-67ec1d471c75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-da3f-7348-84f7-44824690b596.webp",
      "image_media": {
        "alt_text": "Exterior view of townhouses with garages and manicured landscaping.",
        "public_id": "019d08ac-da3f-7348-84f7-44824690b596",
        "storage_key": "property/6767906449166893/019d08ac-da3f-7348-84f7-44824690b596.webp",
        "width": 1384,
        "height": 913
      },
      "title": "Community",
      "description": "Discover comfortable living in these townhomes, featuring attached garages and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of townhouses with garages and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c6a99f5-04c8-499b-a3b3-1eda94d14cac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-dab0-744c-8960-ecbf28fb123c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
        "public_id": "019d08ac-dab0-744c-8960-ecbf28fb123c",
        "storage_key": "property/6767906449166893/019d08ac-dab0-744c-8960-ecbf28fb123c.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Townhome-style apartments with attached garages and ample parking available.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d48e6db2-d61b-4d09-9f31-2a7ef10eff92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-d4dd-70c9-8136-88cc34dca160.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking lot and covered parking.",
        "public_id": "019d08ac-d4dd-70c9-8136-88cc34dca160",
        "storage_key": "property/6767906449166893/019d08ac-d4dd-70c9-8136-88cc34dca160.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "View of the apartment building exterior, surrounded by lush trees, with a parking lot featuring covered parking spaces.",
      "link": "",
      "alt_text": "Apartment building exterior with parking lot and covered parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df1ab610-2ac1-46b0-b9ea-950e285d296d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-fac7-731a-8b9f-e3c23edc2bc9.webp",
      "image_media": {
        "alt_text": "Bedroom with ensuite vanity and mirrored closet.",
        "public_id": "019d08ac-fac7-731a-8b9f-e3c23edc2bc9",
        "storage_key": "property/6767906449166893/019d08ac-fac7-731a-8b9f-e3c23edc2bc9.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a vanity area with a sink and ample closet space with mirrored doors.",
      "link": "",
      "alt_text": "Bedroom with ensuite vanity and mirrored closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80579f2b-4a82-4b43-a972-f83a8338942b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-cacf-779d-a612-6a1fa2089d74.webp",
      "image_media": {
        "alt_text": "Pathway through a green, tree-lined courtyard with picnic tables and apartment buildings in the background.",
        "public_id": "019d08ac-cacf-779d-a612-6a1fa2089d74",
        "storage_key": "property/6767906449166893/019d08ac-cacf-779d-a612-6a1fa2089d74.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy the lush, green courtyards with ample space for outdoor relaxation and gatherings.",
      "link": "",
      "alt_text": "Pathway through a green, tree-lined courtyard with picnic tables and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a62896c8-ab01-445f-82ec-330f047a62c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-c5ce-76bc-b915-73c8c563d0f6.webp",
      "image_media": {
        "alt_text": "Two lounge chairs facing a swimming pool with drinks on a side table.",
        "public_id": "019d08ac-c5ce-76bc-b915-73c8c563d0f6",
        "storage_key": "property/6767906449166893/019d08ac-c5ce-76bc-b915-73c8c563d0f6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and refreshing drinks. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Two lounge chairs facing a swimming pool with drinks on a side table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cfde4698-239f-46e8-b68d-bacd8a51305d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-bc5d-7326-9830-dcb7ae3713dd.webp",
      "image_media": {
        "alt_text": "Cozy seating area with plush leather chairs around a rustic coffee table, centered by a stone fireplace with a crackling fire.",
        "public_id": "019d08ac-bc5d-7326-9830-dcb7ae3713dd",
        "storage_key": "property/6767906449166893/019d08ac-bc5d-7326-9830-dcb7ae3713dd.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lounge area, featuring comfortable seating and a beautiful stone fireplace, perfect for gathering with friends or enjoying a quiet evening.",
      "link": "",
      "alt_text": "Cozy seating area with plush leather chairs around a rustic coffee table, centered by a stone fireplace with a crackling fire.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_667bebcf-0e3b-4755-b16d-e2f5c781ad3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-b684-7408-ab50-aaecfcddacb4.webp",
      "image_media": {
        "alt_text": "A common area with a round table, four chairs, and a water cooler.",
        "public_id": "019d08ac-b684-7408-ab50-aaecfcddacb4",
        "storage_key": "property/6767906449166893/019d08ac-b684-7408-ab50-aaecfcddacb4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in this cozy common area, complete with comfortable seating and a convenient water cooler.",
      "link": "",
      "alt_text": "A common area with a round table, four chairs, and a water cooler.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9bc67771-05ec-4a04-9d86-2bdd625052bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-aed5-75a8-bedd-5ae0c7f7448d.webp",
      "image_media": {
        "alt_text": "A leasing office with a round table, chairs, water cooler, and computer desk.",
        "public_id": "019d08ac-aed5-75a8-bedd-5ae0c7f7448d",
        "storage_key": "property/6767906449166893/019d08ac-aed5-75a8-bedd-5ae0c7f7448d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "The leasing office at this property features a comfortable seating area with a round table and chairs, a water cooler, and a computer station for resident convenience.",
      "link": "",
      "alt_text": "A leasing office with a round table, chairs, water cooler, and computer desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d6050f5-cc75-44fd-9ff4-eb93e6c99c16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-aa6e-701c-8bd3-3802d313695b.webp",
      "image_media": {
        "alt_text": "Coffee bar area with a Keurig coffee maker, red mugs, and a decorative sign for Hathaway Court.",
        "public_id": "019d08ac-aa6e-701c-8bd3-3802d313695b",
        "storage_key": "property/6767906449166893/019d08ac-aa6e-701c-8bd3-3802d313695b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee at the coffee bar, featuring a Keurig coffee maker, mugs, and a sign for Hathaway Court.",
      "link": "",
      "alt_text": "Coffee bar area with a Keurig coffee maker, red mugs, and a decorative sign for Hathaway Court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3874879f-8aa3-4d57-8bed-fe84f30b24e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-a736-700c-8156-a914fd44317c.webp",
      "image_media": {
        "alt_text": "Hathaway Court property floor plans including 1, 2, and 3 bedroom layouts.",
        "public_id": "019d08ac-a736-700c-8156-a914fd44317c",
        "storage_key": "property/6767906449166893/019d08ac-a736-700c-8156-a914fd44317c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Floorplan",
      "description": "Explore the variety of living spaces at Hathaway Court with our detailed floor plans. We offer 1, 2, and 3 bedroom options to suit your needs.",
      "link": "",
      "alt_text": "Hathaway Court property floor plans including 1, 2, and 3 bedroom layouts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc3fb717-f216-4d0c-94de-89287d9b5dba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-a44d-7258-a065-f1a0a70ce047.webp",
      "image_media": {
        "alt_text": "Lobby area with coffee bar, seating, and view of pool through windows.",
        "public_id": "019d08ac-a44d-7258-a065-f1a0a70ce047",
        "storage_key": "property/6767906449166893/019d08ac-a44d-7258-a065-f1a0a70ce047.webp",
        "width": 2052,
        "height": 1467
      },
      "title": "Community",
      "description": "Welcome to our spacious lobby, complete with a coffee bar and comfortable seating. Enjoy the view of the outdoor pool through the large windows.",
      "link": "",
      "alt_text": "Lobby area with coffee bar, seating, and view of pool through windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a80caef1-263a-4654-bde6-12185253fbcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-9d0a-7592-8224-1931554223f6.webp",
      "image_media": {
        "alt_text": "Interior view of Hathaway Court apartment building lobby with seating and display cases.",
        "public_id": "019d08ac-9d0a-7592-8224-1931554223f6",
        "storage_key": "property/6767906449166893/019d08ac-9d0a-7592-8224-1931554223f6.webp",
        "width": 2048,
        "height": 1464
      },
      "title": "Community",
      "description": "Welcome to Hathaway Court, where comfort meets convenience. Our spacious lobby features ample seating and informative display cases showcasing our floor plans.",
      "link": "",
      "alt_text": "Interior view of Hathaway Court apartment building lobby with seating and display cases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41842414-e5ad-4bfc-b3e7-55b1f564d1a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-9813-71ad-a0cf-ffe124d6db3e.webp",
      "image_media": {
        "alt_text": "Pathway to building entrance with stone walls and decorative lamps",
        "public_id": "019d08ac-9813-71ad-a0cf-ffe124d6db3e",
        "storage_key": "property/6767906449166893/019d08ac-9813-71ad-a0cf-ffe124d6db3e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Beautiful stone pathway leading to the community building, lined with lush trees and a charming water feature.",
      "link": "",
      "alt_text": "Pathway to building entrance with stone walls and decorative lamps",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b2ef2a6-d774-4eb4-b9ac-c4283e5dbcc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-93ad-758c-9933-c38922dd6781.webp",
      "image_media": {
        "alt_text": "Bedroom with vaulted ceiling and en-suite bathroom.",
        "public_id": "019d08ac-93ad-758c-9933-c38922dd6781",
        "storage_key": "property/6767906449166893/019d08ac-93ad-758c-9933-c38922dd6781.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious bedroom with vaulted ceilings and a private en-suite bathroom, offering comfort and convenience.",
      "link": "",
      "alt_text": "Bedroom with vaulted ceiling and en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15641994-bfce-46e2-8fbe-e383a572a133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-93a9-7157-9538-334275e8aeaa.webp",
      "image_media": {
        "alt_text": "Bedroom with open closet and view into hallway",
        "public_id": "019d08ac-93a9-7157-9538-334275e8aeaa",
        "storage_key": "property/6767906449166893/019d08ac-93a9-7157-9538-334275e8aeaa.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large open closet with shelving and a door leading to the hallway.",
      "link": "",
      "alt_text": "Bedroom with open closet and view into hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7607ad9e-429c-4c3b-99fc-d566fc15c060",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-86f2-724a-855a-252da70619e8.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet and hardwood floors, large windows, and a glass door leading to a balcony.",
        "public_id": "019d08ac-86f2-724a-855a-252da70619e8",
        "storage_key": "property/6767906449166893/019d08ac-86f2-724a-855a-252da70619e8.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living area with natural light streaming through large windows and a glass door, showcasing both carpeted and hardwood flooring.",
      "link": "",
      "alt_text": "Empty living room with carpet and hardwood floors, large windows, and a glass door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ce24278-67a1-45b6-9ae2-b135cbb63afb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-0576-720d-84f8-9ecb13f081d7.webp",
      "image_media": {
        "alt_text": "Closet with wire shelving and a full-length mirror.",
        "public_id": "019d08ad-0576-720d-84f8-9ecb13f081d7",
        "storage_key": "property/6767906449166893/019d08ad-0576-720d-84f8-9ecb13f081d7.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious closet with ample wire shelving for storage, complemented by a full-length mirror reflecting an adjacent room.",
      "link": "",
      "alt_text": "Closet with wire shelving and a full-length mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9839ed49-b2e3-4532-b823-d7c6a7eb3047",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-84a6-7067-855c-636655bffe7d.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, sink, and white cabinets.",
        "public_id": "019d08ac-84a6-7067-855c-636655bffe7d",
        "storage_key": "property/6767906449166893/019d08ac-84a6-7067-855c-636655bffe7d.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "View of a tidy kitchen featuring modern black appliances, a stainless steel sink, and ample white cabinetry.",
      "link": "",
      "alt_text": "Kitchen with black appliances, sink, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8979215d-6253-4f84-b6e5-5b499abadbda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-f51f-7226-9e6d-5731981c1654.webp",
      "image_media": {
        "alt_text": "Playground with slide, swings, and climbing structures.",
        "public_id": "019d08ac-f51f-7226-9e6d-5731981c1654",
        "storage_key": "property/6767906449166893/019d08ac-f51f-7226-9e6d-5731981c1654.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "A fun playground area for children, complete with slides, climbing structures, and swings, set amidst lush greenery.",
      "link": "",
      "alt_text": "Playground with slide, swings, and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8931249f-e6ab-48db-ba04-8ec669d54538",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-84a6-7067-855c-66d922952bd7.webp",
      "image_media": {
        "alt_text": "Open-plan living and dining area with kitchen access.",
        "public_id": "019d08ac-84a6-7067-855c-66d922952bd7",
        "storage_key": "property/6767906449166893/019d08ac-84a6-7067-855c-66d922952bd7.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious open-plan living and dining area with a glimpse of the kitchen, featuring carpeted floors and natural light.",
      "link": "",
      "alt_text": "Open-plan living and dining area with kitchen access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb03f977-0b20-4e06-8936-401b332ac8b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-8163-714b-b1e9-ee087c7dc4a9.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "019d08ac-8163-714b-b1e9-ee087c7dc4a9",
        "storage_key": "property/6767906449166893/019d08ac-8163-714b-b1e9-ee087c7dc4a9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub/shower combination, a toilet, and a vanity with a sink and ample counter space.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ae2ddf2-c991-4763-b176-dc26a4ffec5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-7a89-741e-9f63-6074bb74839b.webp",
      "image_media": {
        "alt_text": "Washer and dryer with laundry basket and cleaning supplies.",
        "public_id": "019d08ac-7a89-741e-9f63-6074bb74839b",
        "storage_key": "property/6767906449166893/019d08ac-7a89-741e-9f63-6074bb74839b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "On-site laundry facilities featuring a washer, dryer, and convenient storage for your laundry essentials.",
      "link": "",
      "alt_text": "Washer and dryer with laundry basket and cleaning supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71c8e9c9-8b81-4829-be39-6d39e5425bea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-76f3-70f5-90ce-05cb513cb960.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and bathroom entrance.",
        "public_id": "019d08ac-76f3-70f5-90ce-05cb513cb960",
        "storage_key": "property/6767906449166893/019d08ac-76f3-70f5-90ce-05cb513cb960.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, leading to a convenient walk-in closet and a well-appointed bathroom.",
      "link": "",
      "alt_text": "Bedroom with closet and bathroom entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d321d19-0b65-48c7-a910-375ecf223bc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-739e-74aa-b808-32ba4ce7e0e6.webp",
      "image_media": {
        "alt_text": "Bright living room and kitchen area with beige carpet and white walls.",
        "public_id": "019d08ac-739e-74aa-b808-32ba4ce7e0e6",
        "storage_key": "property/6767906449166893/019d08ac-739e-74aa-b808-32ba4ce7e0e6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living area with an open-concept kitchen, featuring neutral carpeting and abundant natural light. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Bright living room and kitchen area with beige carpet and white walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a889ee1-ad21-4f36-a6bd-94a98c39d416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-741a-762a-9a0b-3165eb177e8c.webp",
      "image_media": {
        "alt_text": "Bedroom closet with mirrored sliding doors and built-in shelving.",
        "public_id": "019d08ac-741a-762a-9a0b-3165eb177e8c",
        "storage_key": "property/6767906449166893/019d08ac-741a-762a-9a0b-3165eb177e8c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom closet featuring mirrored sliding doors and ample shelving for storage.",
      "link": "",
      "alt_text": "Bedroom closet with mirrored sliding doors and built-in shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dedcce2f-69e2-4413-805e-24da5e9f0363",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-6d0f-773d-a83b-f4a37eb54526.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, dark countertops, a sink, and a black refrigerator.",
        "public_id": "019d08ac-6d0f-773d-a83b-f4a37eb54526",
        "storage_key": "property/6767906449166893/019d08ac-6d0f-773d-a83b-f4a37eb54526.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "A view of the kitchen showcasing ample cabinet space, a double-basin sink, and a full-sized refrigerator. This space offers a functional layout for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, dark countertops, a sink, and a black refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_926e134d-fe3a-4204-90ad-cef507dfa471",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-666a-73cf-9be8-16a08127a934.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, sink, vanity, and mirror.",
        "public_id": "019d08ac-666a-73cf-9be8-16a08127a934",
        "storage_key": "property/6767906449166893/019d08ac-666a-73cf-9be8-16a08127a934.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a toilet, vanity with sink, and a large mirror. Decorated with shelving and fresh towels.",
      "link": "",
      "alt_text": "Bathroom with a toilet, sink, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba487054-0c4d-4618-abc8-346eb65fef09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-6517-7288-8695-4ff6417164dc.webp",
      "image_media": {
        "alt_text": "Bunk beds with space-themed bedding, a desk with a monitor, and a closet.",
        "public_id": "019d08ac-6517-7288-8695-4ff6417164dc",
        "storage_key": "property/6767906449166893/019d08ac-6517-7288-8695-4ff6417164dc.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring bunk beds with fun space-themed bedding, a built-in desk with a monitor, and a closet for storage.",
      "link": "",
      "alt_text": "Bunk beds with space-themed bedding, a desk with a monitor, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2c38784-0d65-475c-8b37-fd72348a527a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-656c-71af-94b8-ae27954a02b2.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, water heater, and cabinets.",
        "public_id": "019d08ac-656c-71af-94b8-ae27954a02b2",
        "storage_key": "property/6767906449166893/019d08ac-656c-71af-94b8-ae27954a02b2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a washer, dryer, and ample storage cabinets. Includes a water heater for your comfort.",
      "link": "",
      "alt_text": "Laundry room with washer, dryer, water heater, and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bf16a86-5421-4d4c-b5f9-35f1e7d4dda9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-5b1d-7529-a090-cda6489d60e5.webp",
      "image_media": {
        "alt_text": "Bunk bed with desk and chair, space-themed bedding and curtains, and a window.",
        "public_id": "019d08ac-5b1d-7529-a090-cda6489d60e5",
        "storage_key": "property/6767906449166893/019d08ac-5b1d-7529-a090-cda6489d60e5.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a space-themed bunk bed with an integrated desk and chair. The room includes a large window with coordinating curtains, creating a fun and functional living space.",
      "link": "",
      "alt_text": "Bunk bed with desk and chair, space-themed bedding and curtains, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6e8f75f-3a80-4893-b8a2-05811daf79d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-573b-75ac-a5e8-20a8bb2aec6e.webp",
      "image_media": {
        "alt_text": "Bedroom with a large mirrored closet and a vanity.",
        "public_id": "019d08ac-573b-75ac-a5e8-20a8bb2aec6e",
        "storage_key": "property/6767906449166893/019d08ac-573b-75ac-a5e8-20a8bb2aec6e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Bedroom featuring a spacious mirrored closet and a separate vanity area with a sink and ample counter space.",
      "link": "",
      "alt_text": "Bedroom with a large mirrored closet and a vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e19af15-e078-49a9-be26-539d0acad241",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-5480-732b-95ac-932dfd77cb2d.webp",
      "image_media": {
        "alt_text": "Living room with a leather couch, coffee table, TV, and view into the kitchen and bathroom.",
        "public_id": "019d08ac-5480-732b-95ac-932dfd77cb2d",
        "storage_key": "property/6767906449166893/019d08ac-5480-732b-95ac-932dfd77cb2d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Step into comfort and style with this beautifully appointed living space, featuring a cozy seating area, entertainment center, and an open-concept kitchen and bathroom.",
      "link": "",
      "alt_text": "Living room with a leather couch, coffee table, TV, and view into the kitchen and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66b45d70-371e-4d43-bcfc-4f3f50d15318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ac-47b5-75da-a75a-ab1f68d7bae3.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black refrigerator, and dishwasher.",
        "public_id": "019d08ac-47b5-75da-a75a-ab1f68d7bae3",
        "storage_key": "property/6767906449166893/019d08ac-47b5-75da-a75a-ab1f68d7bae3.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A clean and bright kitchen featuring white cabinetry, a black refrigerator, and a dishwasher. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, black refrigerator, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b6d7d91d-ac11-4671-bd35-95fbcabef951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Brix Tavern - Tualatin",
      "poi_type": "Restaurants",
      "poi_address": "8187 SW Tualatin-Sherwood Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Cozy space offering classic American comfort food and an extensive selection of beers.",
      "poi_long_description": "People say this restaurant offers delicious calamari, sandwiches, and a variety of brunch options, including biscuits and gravy and bottomless mimosas. They also highlight the friendly and attentive service, the fun and inviting vibe, and the beautiful lake view with outdoor seating.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-fda3-7365-86ea-950809d22d3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fda3-7365-86ea-950809d22d3a",
        "storage_key": "property/6767906449166893/019d08ad-fda3-7365-86ea-950809d22d3a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://brixtavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17735836944645877810&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brix-tavern---tualatin",
      "poi_latitude": "45.3819397",
      "poi_longitude": "-122.761212",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-410-7553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad36-73ec-8830-9135ba33b414",
        "storage_key": "property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0V4UeVzlVQRMvDdj7tZIvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5ebb43d9-5e4d-4a32-938f-dce86e41363f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Oswego Grill - Wilsonville",
      "poi_type": "Restaurants",
      "poi_address": "30080 SW Boones Ferry Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "Wood-grilled steakhouse favorites served in a casual, romantic restaurant with daily happy hours.",
      "poi_long_description": "Diners say this restaurant serves up delicious prime rib, stuffed chicken breast, and a notable steak sandwich. They also highlight the friendly and attentive service, and the warm and inviting atmosphere.\n\nSome reviews mention the wait times for food can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-20e3-7657-b254-8a4c60bdab53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-20e3-7657-b254-8a4c60bdab53",
        "storage_key": "property/6767906449166893/019d08ad-20e3-7657-b254-8a4c60bdab53.webp",
        "width": 1125,
        "height": 742
      },
      "poi_business_url": "http://www.oswegogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=926009135661288947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oswego-grill---wilsonville",
      "poi_latitude": "45.3023128",
      "poi_longitude": "-122.7711996",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-427-2152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad36-73ec-8830-9135ba33b414",
        "storage_key": "property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXGpnu5ulVQR843bFWfY2Qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a5db8f42-d3d5-4e59-80ef-53af85684c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "7715 SW Nyberg St Suite D, Tualatin, OR 97062, USA",
      "poi_short_description": "Fast-food chain specializing in Nashville-style fried chicken, sliders and tenders, with spice levels ranging from mild to reaper.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sandwiches, sliders, and tenders, with a variety of spice levels. They highlight the fresh, flavorful chicken, and the quick service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-fd44-70aa-a2bb-daf81b5fc87c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fd44-70aa-a2bb-daf81b5fc87c",
        "storage_key": "property/6767906449166893/019d08ad-fd44-70aa-a2bb-daf81b5fc87c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveshotchicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18204669923263322192&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "45.383002",
      "poi_longitude": "-122.7570445",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-427-1775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad36-73ec-8830-9135ba33b414",
        "storage_key": "property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WRO5sJzlVQRUBhZvdf6o_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4283c29c-6c34-4e52-8de0-0d9b4b99fdee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "McMenamins Wilsonville Old Church & Pub",
      "poi_type": "Restaurants",
      "poi_address": "30340 SW Boones Ferry Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "Airy, 2-story brewery & restaurant from the regional chain in a 1911 church with outdoor seating.",
      "poi_long_description": "Airy, 2-story brewery & restaurant from the regional chain in a 1911 church with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-fcf5-73a0-ba49-31aab294e9d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fcf5-73a0-ba49-31aab294e9d2",
        "storage_key": "property/6767906449166893/019d08ad-fcf5-73a0-ba49-31aab294e9d2.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.mcmenamins.com/wilsonville-old-church-pub?utm_source=Google%20Maps&utm_medium=Website%20Button&utm_campaign=Wilsonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=10952609898150636280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcmenamins-wilsonville-old-church--pub",
      "poi_latitude": "45.3006937",
      "poi_longitude": "-122.7727285",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-427-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-4082-76ed-8cfb-38cd9573f66d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4082-76ed-8cfb-38cd9573f66d",
        "storage_key": "property/6767906449166893/019d08ae-4082-76ed-8cfb-38cd9573f66d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERTaL-lulVQR-CqyRqx8_5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_6dff39b2-ef6b-4d55-962d-51258103243f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "La Industria",
      "poi_type": "Restaurants",
      "poi_address": "20185 SW 112th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "Cool venue featuring globally inspired eats, including sandwiches & tapas, plus craft cocktails.",
      "poi_long_description": "Diners say this Tex Mex restaurant serves up delicious brisket tacos, brussel sprouts, and queso, and they praise the cocktails. They also highlight the friendly and fast service, and the vibrant atmosphere.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-fedc-732d-af7e-50b5939eac01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fedc-732d-af7e-50b5939eac01",
        "storage_key": "property/6767906449166893/019d08ad-fedc-732d-af7e-50b5939eac01.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.laindustriatexmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=242367225962452363&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-industria",
      "poi_latitude": "45.3729155",
      "poi_longitude": "-122.7931115",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-454-0647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad36-73ec-8830-9135ba33b414",
        "storage_key": "property/6767906449166893/019d08ad-ad36-73ec-8830-9135ba33b414.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8_uAlnFtlVQRi1WwOLUPXQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_80aa83f9-eb2c-40c5-adfd-fc91b65ca474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a movie theater. They also highlight the clean, beautiful, and open-air atmosphere, as well as the friendly staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-058e-77cf-86ee-1ba1de8c4247.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-058e-77cf-86ee-1ba1de8c4247",
        "storage_key": "property/6767906449166893/019d08ae-058e-77cf-86ee-1ba1de8c4247.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b2f3-76cb-b98f-ac4175072e7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b2f3-76cb-b98f-ac4175072e7b",
        "storage_key": "property/6767906449166893/019d08ad-b2f3-76cb-b98f-ac4175072e7b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e7c09b4b-a1e0-4897-b734-72f82fbe53ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including organic and healthy options, as well as a hot bar, pizza, and sandwiches. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-04b1-761d-bb40-f26429a34f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-04b1-761d-bb40-f26429a34f74",
        "storage_key": "property/6767906449166893/019d08ae-04b1-761d-bb40-f26429a34f74.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/tigard?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16814592006069935487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "45.3944787",
      "poi_longitude": "-122.7515006",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-639-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b302-7659-a996-fa694316aa44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b302-7659-a996-fa694316aa44",
        "storage_key": "property/6767906449166893/019d08ad-b302-7659-a996-fa694316aa44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbWCletylVQRf93rjFduWek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_578cac3f-51e2-4cbb-9d56-32763a3a3b26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "30300 SW Boones Ferry Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this grocery store offers a wide selection of products, including fresh produce, and is well-stocked. They also highlight the friendly, helpful, and attentive staff, and the clean and easy-to-navigate layout.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-4683-765b-8550-b185a71178ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4683-765b-8550-b185a71178ff",
        "storage_key": "property/6767906449166893/019d08ad-4683-765b-8550-b185a71178ff.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/or/wilsonville/wilsonville/701/00516?cid=loc_70100516_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=716483470638583676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "45.3010224",
      "poi_longitude": "-122.7707979",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-570-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b302-7659-a996-fa694316aa44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b302-7659-a996-fa694316aa44",
        "storage_key": "property/6767906449166893/019d08ad-b302-7659-a996-fa694316aa44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF5Irze5ulVQRfA_aout18Qk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3b388448-31fc-4902-8a8f-6e6b2fc58d9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "20260 SW Pacific Hwy, Sherwood, OR 97140, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a large selection of products, including paint and garden supplies, and offers convenient parking. They also highlight the friendly and helpful staff who are knowledgeable about the products and can assist customers with their projects.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-05ff-77ca-84f0-26dd1d288699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-05ff-77ca-84f0-26dd1d288699",
        "storage_key": "property/6767906449166893/019d08ae-05ff-77ca-84f0-26dd1d288699.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.homedepot.com/l/Sherwood/OR/Sherwood/97140/4015?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9020774296246970413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.37417929999999",
      "poi_longitude": "-122.8347595",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-925-8447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b2f3-76cb-b98f-ac4175072e7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b2f3-76cb-b98f-ac4175072e7b",
        "storage_key": "property/6767906449166893/019d08ad-b2f3-76cb-b98f-ac4175072e7b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ9mGmSFtlVQRLWjGpm06MH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2bb28317-3a1e-4ab2-8e7c-8fce9950b5bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Oregon Institute of Technology Portland-Metro",
      "poi_type": "Education",
      "poi_address": "27500 SW Parkway Ave, Wilsonville, OR 97070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-085c-71ad-af40-34d60d15584b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-085c-71ad-af40-34d60d15584b",
        "storage_key": "property/6767906449166893/019d08ae-085c-71ad-af40-34d60d15584b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oit.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6869375482871485166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-institute-of-technology-portland-metro",
      "poi_latitude": "45.3217129",
      "poi_longitude": "-122.7664651",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-821-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b347-753d-900b-7a68fcd1385e",
        "storage_key": "property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWoYvnxulVQR7hJVLZvsVF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a6aa8d4f-fbf3-42e8-858a-b9d06c7b627d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Tualatin Public Library",
      "poi_type": "Education",
      "poi_address": "18878 SW Martinazzi Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "Community hangout for books, magazines, classes and events, with a maker space, 3D printers, a fireplace and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-0da8-724e-b62e-4622d9b4fc46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0da8-724e-b62e-4622d9b4fc46",
        "storage_key": "property/6767906449166893/019d08ae-0da8-724e-b62e-4622d9b4fc46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tualatinoregon.gov/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=12852134369626835646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-public-library",
      "poi_latitude": "45.3843097",
      "poi_longitude": "-122.7583852",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-691-3074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b347-753d-900b-7a68fcd1385e",
        "storage_key": "property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhe87U4VylVQRvkoymx30W7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_af360ecc-af3a-4a75-a3e9-4b239fcf610d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Old Aurora Colony Museum",
      "poi_type": "Entertainment",
      "poi_address": "15018 2nd St NE, Aurora, OR 97002, USA",
      "poi_short_description": "Museum focused on the mid-1800s Aurora Colony and its residents, along with artifacts, quilts and buildings. Friendly staff, Gift shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-0d67-7403-9d45-48a6190fb36a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0d67-7403-9d45-48a6190fb36a",
        "storage_key": "property/6767906449166893/019d08ae-0d67-7403-9d45-48a6190fb36a.webp",
        "width": 351,
        "height": 456
      },
      "poi_business_url": "http://www.auroracolony.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592449138414683032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-aurora-colony-museum",
      "poi_latitude": "45.2315553",
      "poi_longitude": "-122.7539987",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-678-5754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-42b2-75cf-9c16-cedeca1dfc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-42b2-75cf-9c16-cedeca1dfc3b",
        "storage_key": "property/6767906449166893/019d08ae-42b2-75cf-9c16-cedeca1dfc3b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxnVEBNmlVQRmIOlf9xenE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6c69ac59-5c10-4351-ae4e-c4aadb37d6b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Tualatin high stadium",
      "poi_type": "Entertainment",
      "poi_address": "22300 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-0ed6-713b-afb2-e08c78dba8e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0ed6-713b-afb2-e08c78dba8e8",
        "storage_key": "property/6767906449166893/019d08ae-0ed6-713b-afb2-e08c78dba8e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ttsdschools.org/tuhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=8964509993261762683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-high-stadium",
      "poi_latitude": "45.3590731",
      "poi_longitude": "-122.7700958",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-431-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-41f9-766f-9850-bb4b177d552c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-41f9-766f-9850-bb4b177d552c",
        "storage_key": "property/6767906449166893/019d08ae-41f9-766f-9850-bb4b177d552c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuZD6rE5tlVQRe4jOxVdWaHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ded58e5e-54e4-4245-bf60-dcdf4f47925d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Phoenix & Holly Railroad, Inc",
      "poi_type": "Entertainment",
      "poi_address": "2512 N Holly St, Canby, OR 97013, USA",
      "poi_short_description": "Family-friendly attraction with a petting zoo, a hay pyramid, and a train ride.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1101-724b-be17-e64851c81cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1101-724b-be17-e64851c81cb7",
        "storage_key": "property/6767906449166893/019d08ae-1101-724b-be17-e64851c81cb7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flowerfarmer.com/phoenix__holly_rr",
      "poi_directions_map_url": "https://maps.google.com/?cid=3715215778344122517&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix--holly-railroad-inc",
      "poi_latitude": "45.2839386",
      "poi_longitude": "-122.695853",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-266-3581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-42b2-75cf-9c16-cedeca1dfc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-42b2-75cf-9c16-cedeca1dfc3b",
        "storage_key": "property/6767906449166893/019d08ae-42b2-75cf-9c16-cedeca1dfc3b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaZuv5NvlVQRlbgg_BAZjzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_56d0b4bf-c2b2-47b9-a4f2-d14698872173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Historic Butteville Landing",
      "poi_type": "Entertainment",
      "poi_address": "Butte St NE, Aurora, OR 97002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-152e-7106-b3d2-6ed2c4917362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-152e-7106-b3d2-6ed2c4917362",
        "storage_key": "property/6767906449166893/019d08ae-152e-7106-b3d2-6ed2c4917362.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.butteville.org/history.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6069710033231762909&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "historic-butteville-landing",
      "poi_latitude": "45.2626283",
      "poi_longitude": "-122.8438589",
      "poi_miles_from_property": "14.8",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWnM86pplVQR3VVn1B3xO1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_6721ec8f-a6d1-4145-acd0-0759e8d61dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Randall Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Wilsonville, OR 97070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1694-7499-8969-3d81632877ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1694-7499-8969-3d81632877ab",
        "storage_key": "property/6767906449166893/019d08ae-1694-7499-8969-3d81632877ab.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.wilsonvillefootball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14707953184688062717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "randall-stadium",
      "poi_latitude": "45.3068731",
      "poi_longitude": "-122.7455982",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-673-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-41f9-766f-9850-bb4b177d552c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-41f9-766f-9850-bb4b177d552c",
        "storage_key": "property/6767906449166893/019d08ae-41f9-766f-9850-bb4b177d552c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6fnI91lulVQR_UBo0n4lHcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_262eb882-f12c-4336-a508-c0819d7e6799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "17942 SW McEwan Rd, Tigard, OR 97224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-162d-73ce-9fea-950a3831d93d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-162d-73ce-9fea-950a3831d93d",
        "storage_key": "property/6767906449166893/019d08ae-162d-73ce-9fea-950a3831d93d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tigard-or/tualatin-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=709569765366759855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.3942716",
      "poi_longitude": "-122.7437279",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-670-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0jwLe9ylVQRrwELMPHl2Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b5da49b8-fe0a-4403-b276-6b7ce3c2e43f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7405 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain, clean gym featuring free weights, sports facilities and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of weights, cardio equipment, and classes, as well as a basketball court, hot tub, sauna, and pool. They also highlight the clean facilities, including the locker rooms and sauna, and the friendly and helpful staff.\n\nOther reviews mention the Wi-Fi can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1851-76e0-b649-97caf569ec92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1851-76e0-b649-97caf569ec92",
        "storage_key": "property/6767906449166893/019d08ae-1851-76e0-b649-97caf569ec92.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1097&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650673231861924082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.385637",
      "poi_longitude": "-122.752729",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-404-0126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyqRr41ylVQR8kB0ia6lUcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b98c6f95-1c17-4b89-b4af-674cf1f0f6e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "The Barbers (Wilsonville)",
      "poi_type": "Health and Wellness",
      "poi_address": "29955 SW Boones Ferry Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "Part of a chain, this local barbershop offers trims, fades, and beard grooming, as well as the latest trends.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1bf2-759f-8890-ac93d4c783b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1bf2-759f-8890-ac93d4c783b0",
        "storage_key": "property/6767906449166893/019d08ae-1bf2-759f-8890-ac93d4c783b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thebarbersonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2262162730946000990&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-barbers-wilsonville",
      "poi_latitude": "45.3038692",
      "poi_longitude": "-122.7723571",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-570-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyR3MzO1ulVQRXvgpsgTRZB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5116f1dc-57bf-4fc5-a247-0bed2fe16627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Emergency Veterinary Clinic of Tualatin",
      "poi_type": "Health and Wellness",
      "poi_address": "8250 SW Tonka St, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1d34-70fd-ba0e-9e40fa4efce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1d34-70fd-ba0e-9e40fa4efce9",
        "storage_key": "property/6767906449166893/019d08ae-1d34-70fd-ba0e-9e40fa4efce9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://evcot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13648983288718338961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emergency-veterinary-clinic-of-tualatin",
      "poi_latitude": "45.3804563",
      "poi_longitude": "-122.7613867",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-691-7922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYUHDYRylVQRkatMVfztar0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7ab61a61-5fa2-45e9-b4a6-7b64ce6075b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "7081 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1dec-701d-95ed-add5029f1e3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1dec-701d-95ed-add5029f1e3b",
        "storage_key": "property/6767906449166893/019d08ae-1dec-701d-95ed-add5029f1e3b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tualatin-or-258",
      "poi_directions_map_url": "https://maps.google.com/?cid=13056142182721210940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.3842479",
      "poi_longitude": "-122.7506722",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-692-1501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-zeghotylVQRPEoXCiS8MLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_869fe2b9-d447-40e2-9c5c-1f79537addc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Metro Gymnastics Center",
      "poi_type": "Health and Wellness",
      "poi_address": "18084 SW Lower Boones Ferry Rd, Tigard, OR 97224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-1f17-7005-ab85-892c6c53a896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1f17-7005-ab85-892c6c53a896",
        "storage_key": "property/6767906449166893/019d08ae-1f17-7005-ab85-892c6c53a896.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://metrogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14246720838715326546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics-center",
      "poi_latitude": "45.3896264",
      "poi_longitude": "-122.7532849",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-620-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b347-753d-900b-7a68fcd1385e",
        "storage_key": "property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0VmM1pJylVQRUkDI1R6FtsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f6c4691d-638c-4fb6-a5ed-5a4a4ed573a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "CorePower Yoga - Bridgeport Village",
      "poi_type": "Health and Wellness",
      "poi_address": "7497 SW Bridgeport Rd, Tualatin, OR 97224, USA",
      "poi_short_description": "Chain studio offering a range of yoga classes, including hot yoga, in a clean space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-226c-7729-8f54-b0d732cc56eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-226c-7729-8f54-b0d732cc56eb",
        "storage_key": "property/6767906449166893/019d08ae-226c-7729-8f54-b0d732cc56eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/or/portland/bridgeport-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=11620332859001517382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corepower-yoga---bridgeport-village",
      "poi_latitude": "45.39395469999999",
      "poi_longitude": "-122.7538883",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b347-753d-900b-7a68fcd1385e",
        "storage_key": "property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzf0VbOtylVQRRrWVCCu3Q6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2eb7f9f4-0934-43ea-a50b-1ed8d269fa78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "The Little Gym of Lake Oswego",
      "poi_type": "Health and Wellness",
      "poi_address": "5820 Jean Rd, Lake Oswego, OR 97035, USA",
      "poi_short_description": "Gymnasium offering classes for kids and parents, plus hosting birthday bashes.",
      "poi_long_description": "People say this gymnastics center offers a fun and welcoming environment for children. They highlight the teachers are kind, patient, and dedicated, providing extra encouragement and personalized instruction. They also like the teachers' cheerful and hardworking approach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-24a3-71db-964a-8a388e6883f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-24a3-71db-964a-8a388e6883f9",
        "storage_key": "property/6767906449166893/019d08ae-24a3-71db-964a-8a388e6883f9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.thelittlegym.com/oregon-lake-oswego/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1838162740133396649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-little-gym-of-lake-oswego",
      "poi_latitude": "45.3969142",
      "poi_longitude": "-122.7369822",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-595-9702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b347-753d-900b-7a68fcd1385e",
        "storage_key": "property/6767906449166893/019d08ad-b347-753d-900b-7a68fcd1385e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxfOOAeZylVQRqYAC7UV3ghk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a7028a96-6815-4974-bf03-5c4a704a2c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "MALVA. house of hair",
      "poi_type": "Health and Wellness",
      "poi_address": "18081 SW Lower Boones Ferry Rd, Portland, OR 97224, USA",
      "poi_short_description": "Modern salon offering haircuts, color treatment and highlighting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2486-7684-aeb0-51cb2312965f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2486-7684-aeb0-51cb2312965f",
        "storage_key": "property/6767906449166893/019d08ae-2486-7684-aeb0-51cb2312965f.webp",
        "width": 975,
        "height": 651
      },
      "poi_business_url": "http://www.malvahouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11751630286483676241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "malva-house-of-hair",
      "poi_latitude": "45.3907991",
      "poi_longitude": "-122.7526492",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-940-2954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQPb5exylVQRUdyUlXstFqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_47b4d42a-a206-4b13-bf1f-c79ce7618911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Luxor Nails and Spa Tualatin",
      "poi_type": "Health and Wellness",
      "poi_address": "7080 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Relaxed nail salon and spa specializing in gel, acrylic and dip manicures and pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2593-76dd-bc75-2cada651960d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2593-76dd-bc75-2cada651960d",
        "storage_key": "property/6767906449166893/019d08ae-2593-76dd-bc75-2cada651960d.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://nailspaluxor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16957814992111879193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "luxor-nails-and-spa-tualatin",
      "poi_latitude": "45.3821678",
      "poi_longitude": "-122.7483139",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-482-5076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdVXsjFzlVQRGUSfk-NCVus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_b4e6ee96-f613-4baf-9b02-0e07edb1011d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Legacy Meridian Park Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19300 SW 65th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-6cb8-75ab-ac5c-6feac307723a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6cb8-75ab-ac5c-6feac307723a",
        "storage_key": "property/6767906449166893/019d08ad-6cb8-75ab-ac5c-6feac307723a.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-meridian-park-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13283930296531003614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-meridian-park-medical-center",
      "poi_latitude": "45.3784235",
      "poi_longitude": "-122.7407424",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-692-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b897-772c-9550-0fb3c10a20ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b897-772c-9550-0fb3c10a20ed",
        "storage_key": "property/6767906449166893/019d08ad-b897-772c-9550-0fb3c10a20ed.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXGsTWBylVQR3qjHMTkAWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2c02b95d-4f1a-4540-a982-fdee1f9af803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Providence Bridgeport Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "18040 SW Lower Boones Ferry Rd, Tigard, OR 97224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2b52-706c-a3eb-6d2567469dd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2b52-706c-a3eb-6d2567469dd9",
        "storage_key": "property/6767906449166893/019d08ae-2b52-706c-a3eb-6d2567469dd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.providence.org/locations/or/bridgeport-health-center?ls=location&y_source=1_OTU3NjQ1Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256402655789041046&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-bridgeport-health-center",
      "poi_latitude": "45.3911401",
      "poi_longitude": "-122.7508208",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b897-772c-9550-0fb3c10a20ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b897-772c-9550-0fb3c10a20ed",
        "storage_key": "property/6767906449166893/019d08ad-b897-772c-9550-0fb3c10a20ed.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0JHEoJzlVQRlsW5pl1-8kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_39abaac2-4f2d-4d2b-8fdd-36fb888a4899",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Cook Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17005 SW 92nd Ave, Tigard, OR 97224, USA",
      "poi_short_description": "Riverside park offering various sports & picnic areas, as well as a playground & a boat ramp.",
      "poi_long_description": "People say this city park offers a playground, walking trails, picnic tables, and a kayak launch. They highlight the park is clean, spacious, and family-friendly, with plenty of parking and restrooms. They also like the beautiful river views and opportunities for kayaking, canoeing, and paddleboarding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2c41-74dc-bdac-0b2f6640c585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2c41-74dc-bdac-0b2f6640c585",
        "storage_key": "property/6767906449166893/019d08ae-2c41-74dc-bdac-0b2f6640c585.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tigard-or.gov/Home/Components/FacilityDirectory/FacilityDirectory/143/181",
      "poi_directions_map_url": "https://maps.google.com/?cid=17281400391354763777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cook-family-park",
      "poi_latitude": "45.39603959999999",
      "poi_longitude": "-122.771663",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-718-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b867-7165-b17b-63f02dfcb264",
        "storage_key": "property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_XlT7xylVQRAUr_Wxje0-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f1e15c16-e69f-4797-a57e-7800deb787a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Langdon Farms Golf Club - Golf Shop",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "24377 Airport Rd NE, Aurora, OR 97002, USA",
      "poi_short_description": "Welcoming 18-hole golf course with a driving range, a restaurant, a bar and a wedding venue.",
      "poi_long_description": "People say this golf course offers well-maintained greens and a challenging layout. They highlight the relaxed yet professional atmosphere and the friendly, accommodating staff. They also like the fast service and delicious food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2bb1-75f4-b678-b575cfaa113c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2bb1-75f4-b678-b575cfaa113c",
        "storage_key": "property/6767906449166893/019d08ae-2bb1-75f4-b678-b575cfaa113c.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.langdonfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8814158709940477898&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "langdon-farms-golf-club---golf-shop",
      "poi_latitude": "45.27485919999999",
      "poi_longitude": "-122.7679285",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-678-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-4758-775c-b5a5-489e4b83d32d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4758-775c-b5a5-489e4b83d32d",
        "storage_key": "property/6767906449166893/019d08ae-4758-775c-b5a5-489e4b83d32d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2e4QTdvlVQRyt_qs6UuUno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5a64cd57-6d7a-40e9-a4d9-685ab571dd46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8100 SW Wilsonville Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "Riverfront park with 126 acres including an off-leash area, athletic fields, playground & trails.",
      "poi_long_description": "People say this park offers a disc golf course, baseball fields, a playground, and walking trails. They highlight the park is well-maintained, spacious, and suitable for families. They also like the ample parking and the variety of activities available. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-6a04-70fd-b5bf-f6911e6809dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6a04-70fd-b5bf-f6911e6809dc",
        "storage_key": "property/6767906449166893/019d08ad-6a04-70fd-b5bf-f6911e6809dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wilsonvilleparksandrec.com/parksrec/page/memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2702584849520774333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "45.2975791",
      "poi_longitude": "-122.7591536",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-682-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b867-7165-b17b-63f02dfcb264",
        "storage_key": "property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZtMh_tulVQRvcwJC5qCgSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6e0a64bc-8fd8-4514-b6e3-4623d9773c4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Charbonneau Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "32020 SW Charbonneau Dr, Wilsonville, OR 97070, USA",
      "poi_short_description": "Relaxed, well-kept course featuring 18 holes, a driving range and a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-2ecf-729b-8224-1c429a9394f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2ecf-729b-8224-1c429a9394f7",
        "storage_key": "property/6767906449166893/019d08ae-2ecf-729b-8224-1c429a9394f7.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "https://www.charbonneaugolfclub.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=2334445540866661710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charbonneau-golf-club",
      "poi_latitude": "45.2884037",
      "poi_longitude": "-122.7587565",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-694-1246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-4758-775c-b5a5-489e4b83d32d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4758-775c-b5a5-489e4b83d32d",
        "storage_key": "property/6767906449166893/019d08ae-4758-775c-b5a5-489e4b83d32d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9b-zMRxvlVQRTh3a2tmdZSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_16b95b3b-6f77-4d86-b1f9-147facd1b5a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Tualatin Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8515 SW Tualatin Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Green space known for its skateboard park, plus a playground, sports fields, dog run & picnic sites.",
      "poi_long_description": "People say this city park is a great place to walk and jog. They highlight the park's suitability for morning jogs and after-work walks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-3320-743e-82ab-daaf414ae4cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3320-743e-82ab-daaf414ae4cd",
        "storage_key": "property/6767906449166893/019d08ae-3320-743e-82ab-daaf414ae4cd.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://www.tualatinoregon.gov/recreation/tualatin-community-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14735714748933122243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-community-park",
      "poi_latitude": "45.385692",
      "poi_longitude": "-122.7635878",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-691-3061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-b867-7165-b17b-63f02dfcb264",
        "storage_key": "property/6767906449166893/019d08ad-b867-7165-b17b-63f02dfcb264.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRiutpZylVQRw6iksX3Gf8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b258d423-ae69-4cb9-8a6c-a93d836c94d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Aurora State Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "22801 Airport Rd NE, Aurora, OR 97002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-32ff-77c7-b713-575ee6cdcfb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-32ff-77c7-b713-575ee6cdcfb9",
        "storage_key": "property/6767906449166893/019d08ae-32ff-77c7-b713-575ee6cdcfb9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.oregon.gov/aviation/Pages/index.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16239907185925270732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aurora-state-airport",
      "poi_latitude": "45.2470883",
      "poi_longitude": "-122.7695989",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-378-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-bdcd-75cb-a8ab-172d427b6902.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-bdcd-75cb-a8ab-172d427b6902",
        "storage_key": "property/6767906449166893/019d08ad-bdcd-75cb-a8ab-172d427b6902.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7M8ZaholVQRzKxj-oq9X-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6f2dafa7-1609-4496-b488-3bfd3ff30d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Wilsonville WES Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Wilsonville, OR 97070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-3333-70bd-84b4-aefd75fceeb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3333-70bd-84b4-aefd75fceeb4",
        "storage_key": "property/6767906449166893/019d08ae-3333-70bd-84b4-aefd75fceeb4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/#tracker/stop/13070",
      "poi_directions_map_url": "https://maps.google.com/?cid=12527591173778871938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilsonville-wes-station",
      "poi_latitude": "45.311358",
      "poi_longitude": "-122.775303",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-47a0-766f-a2dc-9218a3217d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-47a0-766f-a2dc-9218a3217d71",
        "storage_key": "property/6767906449166893/019d08ae-47a0-766f-a2dc-9218a3217d71.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbTLxY1ulVQRgpZobMzx2q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_3ca7b153-d7e0-4f50-81fb-a6641295c475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Lam Research",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11355 SW Leveton Dr, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-3591-74ef-9345-16a3d15d2445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3591-74ef-9345-16a3d15d2445",
        "storage_key": "property/6767906449166893/019d08ae-3591-74ef-9345-16a3d15d2445.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8683645162624889977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research",
      "poi_latitude": "45.38651220000001",
      "poi_longitude": "-122.7923427",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_cRBl5tlVQRebTLeUSBgng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ea0e1a35-574d-4223-94d2-84351d001f5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "Lam Research - Building K",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15674694321931209481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research---building-k",
      "poi_latitude": "45.3849983",
      "poi_longitude": "-122.7886581",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK70m8mBtlVQRCcuKDXCzh9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_93d2e502-96bb-40d9-af05-508ac85d3360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "BIOTRONIK",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6024 Jean Rd, Lake Oswego, OR 97035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-39cd-77bf-ab60-f026e85e3a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-39cd-77bf-ab60-f026e85e3a42",
        "storage_key": "property/6767906449166893/019d08ae-39cd-77bf-ab60-f026e85e3a42.webp",
        "width": 1105,
        "height": 450
      },
      "poi_business_url": "http://www.biotronik.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4545871442089531206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "biotronik",
      "poi_latitude": "45.3957557",
      "poi_longitude": "-122.7411458",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-547-0394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpapHj-VylVQRRtdW1P0tFj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_92aff74b-7015-4b90-a4ca-5ee8f51de8bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "NW Natural Operations & Training Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20285 SW Cipole Rd, Sherwood, OR 97140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-39ea-700c-a872-f0ef1a596a71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-39ea-700c-a872-f0ef1a596a71",
        "storage_key": "property/6767906449166893/019d08ae-39ea-700c-a872-f0ef1a596a71.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12273986279357645837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nw-natural-operations--training-center",
      "poi_latitude": "45.3733845",
      "poi_longitude": "-122.8111636",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-226-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTvX5BNtlVQRDYQhn331Vao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7c5ad1dd-7f64-4d71-98c5-b02ef734d66b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "poi_name": "VAN'S AIRCRAFT",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14401 Keil Rd NE, Aurora, OR 97002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ae-3a7f-75a9-b6db-885933606a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3a7f-75a9-b6db-885933606a31",
        "storage_key": "property/6767906449166893/019d08ae-3a7f-75a9-b6db-885933606a31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.vansaircraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10921163240767208090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vans-aircraft",
      "poi_latitude": "45.2417721",
      "poi_longitude": "-122.7661615",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-678-6545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ad31-712c-966c-67db37f822be",
        "storage_key": "property/6767906449166893/019d08ad-ad31-712c-966c-67db37f822be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRFUjRxmlVQRmrr7yxrEj5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a4a95dae-0fc5-447b-941c-a76fd0cc23e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_6abbceda-80a5-4e0f-84f1-e1e7d8d02daa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_940c1dd2-a40f-4233-886f-f775630dc704",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_922b0d30-a018-431a-8dff-79a08f89327e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_073b12d6-6fc0-46a0-a3ab-6d19d87bda2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_17ee67e1-4279-4cb4-91ae-ed4601c7ca1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_10555a78-55c3-41b0-9a2f-5c94de427d1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_90f3551a-3a12-40ef-8f37-99ebc60c2f9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "rating": "5.0",
      "name": "Lisa Banks",
      "text": "We lived at Hathaway court a little over 2 years. The staff was very friendly. Maintenance issues were handled quickly and effectively. The pool was kept sparkling clean. The grounds were well maintained and beautiful. Our neighbors were quiet and respectful. The location is very convenient as well. We loved our apartment and enjoyed our time at Hathaway court.",
      "date": "2023-12-05",
      "title": ""
    },
    {
      "id": "custom_96fe8962-d57e-4de2-b2bd-a2ef8eb19fa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "rating": "5.0",
      "name": "Miles Ellsworth",
      "text": "Management is amazing, which is super rare to come by these days. They're quick to answer, return calls or emails. They're friendly and helpful when I walk in. Definitely a safe area. Kid friendly. Pet friendly. Maintenance seems quick and responsive. The gym, pool, and spa are a nice addition.",
      "date": "2023-05-01",
      "title": ""
    },
    {
      "id": "custom_9b129e25-ce6c-4c8c-9efa-359167305cad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "rating": "5.0",
      "name": "Kaihyia Fascitelli",
      "text": "We love this place. We have lived here almost 3 years now and have had nothing but great experiences.  Maintenance is fast and courteous, especially Mike! Never had someone come in and do such a thorough job! The office staff is truly wonderful and are always they for help when needed. The office hosts tons of events through the year for the residents and it feels so much more like an extended family rather than a complex. One of the office workers even helped do my 5 year old daughters makeup for Halloween! They are just great. We moved here from out if state and have never felt so at home. So much, we moved our sister here too! Give this place a try, you wont regret it.",
      "date": "2016-12-05",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_be2301d1-8888-4b41-ac37-f523f0d9ce0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166893/019d2bc9-ddf8-704d-89e8-bbc9ba9d1af0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bc9-ddf8-704d-89e8-bbc9ba9d1af0",
        "storage_key": "property/6767906449166893/019d2bc9-ddf8-704d-89e8-bbc9ba9d1af0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hathaway Court Apartments - 2 Bedroom 1 Bath 821 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bhMHCmNszJ9"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a8-86f3-719b-8229-61a2a06a5c04",
      "lead_source": "LANDING_PAGE",
      "name": "Hathaway Court Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "apartments-with-pool-wilsonville-or",
      "search_query": "apartments with pool in Wilsonville OR",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Wilsonville, OR",
      "h2_subtitle": "Discover your next home with a luxurious pool in Wilsonville, Oregon. Hathaway Court offers premium amenities including a refreshing pool for residents.",
      "page_copy": "Welcome to Hathaway Court, where luxury meets comfort in the heart of Wilsonville, OR. Our stunning community offers residents exclusive access to a sparkling pool, perfect for relaxing on sunny days or unwinding after a long day. Situated in a vibrant neighborhood, our apartments with pool in Wilsonville, OR provide an idyllic setting for those seeking both convenience and leisure in one location.\n\nAside from our enticing pool, Hathaway Court features spacious rooms, each designed with walk-in closets to cater to your storage needs. Enjoy the comfort of smoke-free and wheelchair-accessible living spaces, making it an ideal choice for everyone. When you are not lounging by the pool, indulge in the nearby spa facilities or explore the vibrant local area that Wilsonville has to offer. Choose Hathaway Court as your haven where modern living meets serene relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Wilsonville, OR",
      "seo_description": "Explore apartments with pool at Hathaway Court, Wilsonville, OR. Enjoy premium amenities and a serene living experience today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "hathaway-court-fitness-center-apartments",
      "search_query": "Hathaway Court fitness center apartments",
      "category": "Amenity",
      "h1_title": "Hathaway Court Fitness Center Apartments",
      "h2_subtitle": "Experience an active lifestyle at Hathaway Court with premier fitness amenities. Our community offers a dynamic setting for residents seeking wellness and comfort.",
      "page_copy": "Hathaway Court in Wilsonville, OR offers an exceptional living experience designed for those who prioritize health and wellness. Although our property isn't equipped with a fitness center, our residents enjoy nearby trails and parks perfect for jogging, walking, or cycling. The availability of such amenities enables our active community to maintain their fitness routine within a picturesque setting.\n\nFurthermore, Hathaway Court provides luxurious amenities including a resort-style pool and spa facilities, ideal for relaxation after an invigorating workout. Our smoke-free, wheelchair-accessible apartments are complemented by spacious walk-in closets, ensuring comfort and convenience in every aspect of living. Choose Hathaway Court for a lifestyle where exercise and relaxation are seamlessly combined.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hathaway Court Fitness Center Apartments",
      "seo_description": "Explore active living at Hathaway Court in Wilsonville, OR. Enjoy luxury amenities in a vibrant community focused on health and relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "wilsonville-or-apartment-with-spa-services",
      "search_query": "Wilsonville OR apartment with spa services",
      "category": "Amenity",
      "h1_title": "Wilsonville OR Apartment with Spa Services",
      "h2_subtitle": "Discover premium spa services at Hathaway Court in Wilsonville, OR. Indulge in luxury and relaxation right at home with our exclusive amenities.",
      "page_copy": "Welcome to Hathaway Court, an unparalleled apartment community in Wilsonville, OR, where residents can enjoy rejuvenating spa services right on site. Designed with luxury and relaxation in mind, our community provides a peaceful retreat with top-notch amenities that deliver a serene living experience.\n\nAt Hathaway Court, our smoke-free, wheelchair-accessible apartments are designed to offer both convenience and luxury. In addition to the tranquil spa services, you’ll find spacious accommodations featuring walk-in closets and a beautiful pool area for relaxation. Our residents enjoy the combination of modern living with easy access to the surrounding natural beauty of Wilsonville. Choose Hathaway Court for an extraordinary blend of comfort and wellness.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wilsonville OR Apartment with Spa Services",
      "seo_description": "Experience luxury spa services at Hathaway Court in Wilsonville, OR. Enjoy modern amenities and serene living in our premier community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "wilsonville-luxury-apartments-media-center",
      "search_query": "Wilsonville luxury apartments with media center",
      "category": "Amenity",
      "h1_title": "Wilsonville Luxury Apartments with Media Center",
      "h2_subtitle": "Experience luxury living in Wilsonville with state-of-the-art facilities. At Hathaway Court, enjoy your ideal lifestyle in our vibrant community.",
      "page_copy": "Welcome to Hathaway Court, the epitome of luxury living in Wilsonville, OR. While we offer top-tier facilities, please note that Hathaway Court doesn’t currently include a media center. However, our residents enjoy a host of premium amenities designed to elevate their living experience, such as a stunning pool and soothing spa services.\n\nReside in comfort with spacious, smoke-free apartments that boast walk-in closets and are wheelchair accessible, offering the perfect blend of style and functionality. Beyond the comforts of your apartment, Wilsonville presents a vibrant community setting, providing a lovely backdrop for our residents. Choose Hathaway Court for a living experience that provides not just a place to stay, but a place you can truly call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wilsonville Luxury Apartments with Media Center",
      "seo_description": "Discover luxury living at Hathaway Court in Wilsonville, OR. Enjoy modern amenities in a vibrant community setting, designed for comfort and relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-near-clackamas-county",
      "search_query": "smoke free apartments near Clackamas County",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments Near Clackamas County",
      "h2_subtitle": "Discover the benefits of smoke-free living at Hathaway Court. Located near Clackamas County, our community offers a healthy and serene environment.",
      "page_copy": "Located in the charming city of Wilsonville, Hathaway Court is an ideal choice for those seeking smoke-free apartments near Clackamas County. Our community prioritizes a healthy lifestyle, ensuring a clean and refreshing environment for all residents. Enjoy the benefits of a smoke-free living space that promotes wellness and comfort.\n\nBeyond the smoke-free policy, Hathaway Court offers a wide array of amenities, including wheelchair-accessible rooms, walk-in closets, an inviting pool, and relaxing spa facilities. Our commitment to quality living extends to our tranquil surroundings, providing a peaceful retreat while being conveniently located near the attractions and opportunities of Clackamas County. Choose Hathaway Court for a harmonious blend of convenience, luxury, and health-conscious living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments Near Clackamas County",
      "seo_description": "Find smoke-free living at Hathaway Court near Clackamas County. Enjoy luxury amenities and a healthy environment in our Wilsonville community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-wilsonville-or",
      "search_query": "one bedroom apartments wilsonville or",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Wilsonville OR",
      "h2_subtitle": "Find your perfect one-bedroom apartment at Hathaway Court in Wilsonville, OR. Enjoy comfortable living with top amenities and a welcoming community.",
      "page_copy": "Hathaway Court offers an array of one-bedroom apartments in the heart of Wilsonville, OR, designed for modern comfort and convenience. These apartments feature spacious layouts, walk-in closets, and are wheelchair accessible, ensuring residents have a welcoming and accommodating home.\n\nAs part of our vibrant community, you can take advantage of various amenities such as a pristine pool, soothing spa services, and a smoke-free environment that promotes healthy living. Nestled in beautiful Wilsonville, Hathaway Court combines the tranquility of suburban living with easy access to local attractions and the broader Clackamas County area, making it an ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Wilsonville OR",
      "seo_description": "Explore one-bedroom apartments at Hathaway Court in Wilsonville, OR. Enjoy spacious layouts, modern amenities, and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-clackamas-county",
      "search_query": "two bedroom floorplans clackamas county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans Clackamas County",
      "h2_subtitle": "Discover the spacious two-bedroom floorplans at Hathaway Court, perfectly suited for families and individuals alike, nestled in Clackamas County.",
      "page_copy": "Explore the thoughtfully designed two-bedroom floorplans at Hathaway Court, situated in Wilsonville, OR, within the charming Clackamas County region. These apartments boast ample space, walk-in closets, and are wheelchair accessible, providing the perfect combination of comfort and practicality for any lifestyle.\n\nResidents at Hathaway Court can enjoy a healthy, smoke-free environment alongside exceptional amenities like an inviting pool and a relaxing spa. Our location in Wilsonville offers convenient access to the broader Clackamas County while maintaining a peaceful, suburban feel. Choose Hathaway Court for a balanced lifestyle that meets both comfort and convenience in our welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans Clackamas County",
      "seo_description": "Hathaway Court offers spacious two-bedroom floorplans in Clackamas County with luxury amenities, ensuring comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166893",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-97070",
      "search_query": "three bedroom apartments near 97070",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 97070",
      "h2_subtitle": "Explore our spacious three-bedroom apartments near 97070. Hathaway Court provides the perfect blend of comfort and convenience in Wilsonville, OR.",
      "page_copy": "If you are looking for three-bedroom apartments near the 97070 area, Hathaway Court is your ideal destination. Located in the welcoming city of Wilsonville, OR, our community offers spacious living accommodations tailored to meet a variety of needs. Each apartment is designed with expansive living spaces, walk-in closets, and is wheelchair accessible, ensuring a comfortable living environment.\n\nAt Hathaway Court, residents enjoy a smoke-free community along with exclusive amenities including a refreshing pool and a rejuvenating spa. Our strategic location near the 97070 zip code not only provides convenience but also access to the beauty and opportunities found throughout Clackamas County. Experience the perfect blend of suburban charm and modern living at Hathaway Court.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 97070",
      "seo_description": "Find spacious three-bedroom apartments at Hathaway Court near 97070. Enjoy modern comfort and premium amenities in a smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5625"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372407678"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-59MHM3GR"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-674-4636"
    }
  ],
  "custom_qb_id": "5625",
  "custom_repli_id": "18372407678",
  "custom_google_gtm_id": "GTM-59MHM3GR",
  "custom_ppc_tracking_phone_number": "844-674-4636"
};

export const generatedAt = '2026-09-23T19:56:10.118Z';
